import axios from "axios";

export default {
    namespaced: true,
    state:{
      withClosedProjects: false,
      filter: {
        projectId: '',
        type: '',
      },
      options: {
        type: [
          {
            text: 'Functional',
            value: 'FUNC'
          },
          {
            text: 'Non-Functional',
            value: 'N-FUNC'
          },
        ],
        accept: [
          {
            text: 'All',
            value: ''
          },
          {
            text: 'Y',
            value: 'Y'
          }, 
          {
            text: 'N',
            value: 'N'
          }, 
        ]
      }
    },
    getters: {
      filter(state) {
        return state.filter;
      },
      typeOptions(state) {
        return state.options.type;
      },
      withClosedProjects(state) {
        return state.withClosedProjects;
      }
    },
    actions: {
    },
    mutations: {
      updateFilter(state, payload) {
        Object.keys(payload).forEach(key => {
          if (state.filter.hasOwnProperty(key)) {
            state.filter = {
              ...state.filter,
              ...payload
            }
          }
        })
      },
      withClosedProjects(state, value) {
        state.withClosedProjects = value;
      },
      resetFilterFields(state, fieldsToReset) {
        fieldsToReset.forEach(key => {
          if (state.filter.hasOwnProperty(key)) {
            state.filter[key] = ''; // 초기화 값으로 빈 문자열 사용
          }
        }
      );
    },
  }
};